import { global, GlobalComponentType } from '@/context';
import { consume } from '@lit/context';
import { localized } from '@weavedev/lit-i18next';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { QuantityCollapsibleDetailsDto } from '@/api-sdk';
import { QuantityCollapsibleData } from '@/types';
import { QuantityStepMixin } from '../../step/quantity/quantity-step-mixin';

import '@/components/accordion/fg-accordion';
import '@/components/accordion/fg-accordion-footer';
import '@/components/accordion/fg-accordion-title';
import '@/components/configurator/step-collapsible/quantity/fg-collapsible-quantity-wrapper';

@customElement('fg-quantity-stacked')
@localized()
export class FgQuantityStacked extends QuantityStepMixin(LitElement) {
  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @property({ type: Object })
  details!: QuantityCollapsibleDetailsDto;

  @state()
  quantityData?: QuantityCollapsibleData;

  updateComponent(queryString: string | null | undefined) {
    if (queryString === null || queryString === undefined) {
      console.error('Missing query string');
      return;
    }
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: { option: { queryString } },
      }),
    );
  }

  render() {
    const { layout } = this.globalContext;
    return html`
      <fg-accordion-wrapper slot="accordion-content">
        <fg-accordion-title
          part=${layout}
          slot="accordion-wrapper-header"
          index="0"
          title=${this.details?.title}
          a11yTitle=${this.details?.title}
          .description=${{
            selectedOption:
              this.details?.selectedQuantityDescription ?? undefined,
          }}
          .editQueryString=${this.details?.editQueryString}
          .collapseQueryString=${this.details?.collapsibleQueryString}
          .open=${this.details?.open}
          .validationMessage=${this.validationMessage}
          .showValidationMessage=${this.validationConfiguratorContext
            .showValidationMessages[this.quantityStep ?? ''] || false}
          .valid=${this.quantityData?.details?.valid || false}
          @action-edit=${() =>
            this.updateComponent(this.details?.editQueryString)}
        ></fg-accordion-title>

        <fg-collapsible-quantity-wrapper
          index="0"
          .open=${this.details?.open}
          .colors=${this.colors}
          .loading=${this.loading}
          .details=${this.details}
          .quantityData=${this.quantityData}
          .quantityStep=${this.quantityStep}
        ></fg-collapsible-quantity-wrapper>
      </fg-accordion-wrapper>
    `;
  }
}
